import { Box, Button, Grid, Typography } from "@mui/material";
import AlertModal from "components/AlertModal";
import { DefaultUrlWeb } from "config/Configuration";
import React from "react";
import WrapperStepper from "./WrapperStepper";

const steps = [
  {
    label: "شروع قرارداد",
    description: `2023/04/06   16:43`,
  },
  {
    label: "اولین سودی که شما دریافت می کنید",
    description: "2023/05/08   13:00",
  },
  {
    label: "پایان قرارداد",
    description: `2023/05/08   13:00`,
  },
];

export default function SubscriptionSuccessfulModal({
  onClose,
  open,
  variant,
  handleShowView,
}) {
  return (
    <AlertModal open={open} onClose={onClose} variant={variant}>
      <Grid container spacing={1}>
        <Grid item xs={12} mb={2}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h4" fontWeight={400} pb={0.5}>
              Success
            </Typography>

            <Typography color="success.main">
              Subscription successful
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} mb={2}>
          <Box display="flex" justifyContent="space-between" pb={2}>
            <Typography variant="h5" fontWeight={300}>
              {" "}
              Subscription amount
            </Typography>

            <Box display="flex" alignItems="center">
              <img
                src={DefaultUrlWeb + `/images/coin/btc.png`}
                alt=""
                width={25}
                height={25}
              />

              <Typography
                variant="h5"
                color="text.main"
                pl={1}
                fontWeight={400}
              >
                <Typography variant="h5" fontWeight={400}>
                  0.01 BTC
                </Typography>
              </Typography>
            </Box>
          </Box>

          <WrapperStepper steps={steps} />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button color="info" fullWidth onClick={onClose}>
                Back
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button color="success" fullWidth onClick={handleShowView}>
                View
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AlertModal>
  );
}
